import axios from "axios";


const GetLocationList = async () => {
  return axios.get(`Location/GetLocations`).then((response) => response);
};


const AddLocation = async (payload) => {
  const config = {
    method: "post",
    url: `Location/AddLocation`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};


const UpdateLocation = async (payload) => {
  const config = {
    method: "post",
    url: `Location/UpdateLocation`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};

const locationService = {
  GetLocationList,
  AddLocation,
  UpdateLocation,
};

export default locationService;
